<app-slide id="emergencyContactsSlide" title="Emergency Contacts"
    supportingText="Please tell us who we should contact in the event of an emergency. Please include anyone who holds a power of attorney, either medical or financial. If you have pets you can specify who should care for them in an emergency."
    [slideNumber]="slideNumber" [finalSlide]="finalSlide"
    [active]="active.active === 'emergencyContacts' && emergencyContactsDataLoaded === true"
    [slideCompleted]="formState.progress.emergencyContactsComplete" *ngIf="formState.applicationForm === 'ops'">

    <app-spinner *ngIf="loading"></app-spinner>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
        {{ errorMessage }}
    </div>
    <!-- {{formState | json}} -->
    <div id="emergency-contacts-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it again.</p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title}}, {{error.msg}}</a>
            </li>
        </ul>
    </div>
    <!-- {{emergencyContactsForm.value | json}}
    {{emergencyContactsForm.valid}} -->
    <form [formGroup]="emergencyContactsForm" id="emergencyContactsForm" (submit)="onSubmit()" novalidate>
        <div class="section">
            <div class="row">
                <div class="col-md-12">
                    <label class="control-label">Do you wish to provide emergency contacts?</label>
                    <div class="form-group schema-form-radiobuttons">
                        <div class="btn-group toggle-buttons">
                            <label class="btn btn-secondary control-label"
                                [class.active]="emergencyContactsForm.controls['hasEmergencyContacts'].value === false">
                                <input formControlName="hasEmergencyContacts" type="radio" class="sr-only"
                                    [value]="false" /> No
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="emergencyContactsForm.controls['hasEmergencyContacts'].value === true">
                                <input formControlName="hasEmergencyContacts" type="radio" class="sr-only"
                                    [value]="true" /> Yes
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- top section -->

        <div class="container-fluid" formArrayName="contacts"
            *ngIf="emergencyContactsForm.value.hasEmergencyContacts === true">
            <div class="row section" *ngFor="let contactControl of contacts.controls; let i = index;"
                formGroupName="{{i}}">
                <div [id]="'firstName' + i" class="form-group form-group--payment col-md-3"
                    [class.has-success]="contactControl.get('firstName')?.valid"
                    [class.has-error]="contactControl.get('firstName')?.invalid">
                    <label class="control-label">First Name</label>
                    <div class="">
                        <!-- adding "form-group schema-form-number" to 1st field introduces weird whitespace -->

                        <div class="has-feedback">
                            <div class='ng-scope input-group'>
                                <input type="text" formControlName="firstName" class="form-control" />
                                <i class="fa form-control-feedback glyphicon ng-scope"
                                    [class.fa-check-circle-o]="contactControl.get('firstName')?.valid"
                                    [class.fa-times-circle-o]="contactControl.get('firstName')?.invalid"
                                    aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="help-block"
                            *ngIf="contactControl.get('firstName')?.touched && contactControl.get('firstName')?.invalid">
                            <div *ngIf="contactControl.get('firstName')?.hasError('required')" style="margin-top: 1px;">
                                Required
                            </div>
                            <div *ngIf="contactControl.get('firstName')?.hasError('maxlength')"
                                style="margin-top: 1px;">It's too long.
                            </div>
                        </div>
                    </div>
                </div>
                <div [id]="'lastName' + i" class="form-group form-group--payment col-md-3"
                    [class.has-success]="contactControl.get('lastName')?.valid"
                    [class.has-error]="contactControl.get('lastName')?.invalid">
                    <label class="control-label">Last Name</label>
                    <div class="form-group schema-form-number">
                        <div class="has-feedback">
                            <div class='ng-scope input-group'>
                                <input type="text" class="form-control" formControlName="lastName" />
                                <i class="fa form-control-feedback glyphicon ng-scope"
                                    [class.fa-check-circle-o]="contactControl.get('lastName')?.valid"
                                    [class.fa-times-circle-o]="contactControl.get('lastName')?.invalid"
                                    aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="help-block"
                            *ngIf="contactControl.get('lastName')?.touched && contactControl.get('lastName')?.invalid">
                            <div *ngIf="contactControl.get('lastName')?.hasError('required')" style="margin-top: 1px;">
                                Required
                            </div>
                            <div *ngIf="contactControl.get('lastName')?.hasError('maxlength')" style="margin-top: 1px;">
                                It's too long.
                            </div>
                        </div>
                    </div>
                </div>

                <div [id]="'phone' + i" class="form-group form-group--payment col-md-3"
                    [class.has-success]="contactControl.get('phone')?.valid"
                    [class.has-error]="contactControl.get('phone')?.invalid">
                    <label class="control-label">Phone Number</label>
                    <div class="form-group schema-form-number">
                        <div class="has-feedback">
                            <div class='ng-scope input-group'>
                                <input type="tel" class="form-control" formControlName="phone" />
                                <i class="fa form-control-feedback glyphicon ng-scope"
                                    [class.fa-check-circle-o]="contactControl.get('phone')?.valid"
                                    [class.fa-times-circle-o]="contactControl.get('phone')?.invalid"
                                    aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="help-block"
                            *ngIf="contactControl.get('phone')?.touched && contactControl.get('phone')?.invalid">
                            <div *ngIf="contactControl.get('phone')?.hasError('required')" style="margin-top: 1px;">
                                Required
                            </div>
                            <div *ngIf="contactControl.get('phone')?.hasError('maxlength')" style="margin-top: 1px;">
                                It's too long.
                            </div>
                            <div *ngIf="contactControl.get('phone')?.hasError('pattern')" style="margin-top: 1px;">
                                Not a valid UK number
                            </div>
                        </div>
                    </div>
                </div>

                <div [id]="'email' + i" class="form-group form-group--payment col-md-3"
                    [class.has-success]="contactControl.get('email')?.valid"
                    [class.has-error]="contactControl.get('email')?.invalid">
                    <label class="control-label">Email Address</label>
                    <div class="form-group schema-form-number">
                        <div class="has-feedback">
                            <div class='ng-scope input-group'>
                                <input type="tel" class="form-control" formControlName="email" />
                                <i class="fa form-control-feedback glyphicon ng-scope"
                                    [class.fa-check-circle-o]="contactControl.get('email')?.valid"
                                    [class.fa-times-circle-o]="contactControl.get('email')?.invalid"
                                    aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="help-block"
                            *ngIf="contactControl.get('email')?.touched && contactControl.get('email')?.invalid">
                            <div *ngIf="contactControl.get('email')?.hasError('required')" style="margin-top: 1px;">
                                Required
                            </div>
                            <div *ngIf="contactControl.get('email')?.hasError('maxlength')" style="margin-top: 1px;">
                                It's too long.
                            </div>
                            <div *ngIf="contactControl.get('email')?.hasError('pattern') || contactControl.get('email')?.hasError('email')"
                                style="margin-top: 1px;">
                                Not a valid email
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <label class="control-label">Relationship to you (tick all that apply)</label>
                    <div class="form-group schema-form-radiobuttons">
                        <div class="btn-group toggle-buttons">
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isLeadFinancialPowerOfAttorney')?.value === true">
                                <input
                                    (click)="contactControl.get('isLeadFinancialPowerOfAttorney')?.setValue(!contactControl.get('isLeadFinancialPowerOfAttorney')?.value)"
                                    formControlName="isLeadFinancialPowerOfAttorney" type="radio" class="sr-only"
                                    [value]="contactControl.get('isLeadFinancialPowerOfAttorney')?.value" />
                                Financial
                                Power Of
                                Attorney
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isLeadMedicalPowerOfAttorney')?.value === true">
                                <input
                                    (click)="contactControl.get('isLeadMedicalPowerOfAttorney')?.setValue(!contactControl.get('isLeadMedicalPowerOfAttorney')?.value)"
                                    formControlName="isLeadMedicalPowerOfAttorney" type="radio" class="sr-only"
                                    [value]="contactControl.get('isLeadMedicalPowerOfAttorney')?.value" /> Medical
                                Power Of
                                Attorney
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isLeadNextOfKin')?.value === true">
                                <input
                                    (click)="contactControl.get('isLeadNextOfKin')?.setValue(!contactControl.get('isLeadNextOfKin')?.value)"
                                    formControlName="isLeadNextOfKin" type="radio" class="sr-only"
                                    [value]="contactControl.get('isLeadNextOfKin')?.value" />
                                Next of Kin
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" *ngIf="model.isJointApplication === true">
                    <label class="control-label">Relationship to the joint applicant (tick all that apply)</label>
                    <div class="form-group schema-form-radiobuttons">
                        <div class="btn-group toggle-buttons">
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isJointFinancialPowerOfAttorney')?.value === true">
                                <input
                                    (click)="contactControl.get('isJointFinancialPowerOfAttorney')?.setValue(!contactControl.get('isJointFinancialPowerOfAttorney')?.value)"
                                    formControlName="isJointFinancialPowerOfAttorney" type="radio" class="sr-only"
                                    [value]="contactControl.get('isJointFinancialPowerOfAttorney')?.value" />
                                Financial
                                Power Of
                                Attorney
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isJointMedicalPowerOfAttorney')?.value === true">
                                <input
                                    (click)="contactControl.get('isJointMedicalPowerOfAttorney')?.setValue(!contactControl.get('isJointMedicalPowerOfAttorney')?.value)"
                                    formControlName="isJointMedicalPowerOfAttorney" type="radio" class="sr-only"
                                    [value]="contactControl.get('isJointMedicalPowerOfAttorney')?.value" /> Medical
                                Power Of
                                Attorney
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isJointNextOfKin')?.value === true">
                                <input
                                    (click)="contactControl.get('isJointNextOfKin')?.setValue(!contactControl.get('isJointNextOfKin')?.value)"
                                    formControlName="isJointNextOfKin" type="radio" class="sr-only"
                                    [value]="contactControl.get('isJointNextOfKin')?.value" />
                                Next of Kin
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-md-12">
                    <label class="control-label">Will this contact care for your pets in an emergency?</label>
                    <div class="form-group schema-form-radiobuttons">
                        <div class="btn-group toggle-buttons">
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isPetContact')?.value === false">
                                <input formControlName="isPetContact" type="radio" class="sr-only" [value]="false" /> No
                            </label>
                            <label class="btn btn-secondary control-label"
                                [class.active]="contactControl.get('isPetContact')?.value === true">
                                <input formControlName="isPetContact" type="radio" class="sr-only" [value]="true" /> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="pull-right btn-toolbar">
                    <button type="button" class="btn btn-secondary " (click)="add()"
                        *ngIf="emergencyContactsForm.value.contacts.length === (i + 1)">Add Another</button>
                    <button type="button" class="btn btn-danger" (click)="remove(i)"
                        *ngIf="emergencyContactsForm.value.contacts.length > 1">Remove
                        {{contactControl.get('firstName')?.value}}</button>
                </div>
            </div>
        </div>
        <div class="section ng-empty" *ngIf="showSubmit">
            <div class="row">
                <div class="col-sm-8">
                    <div class="form-group ">
                        <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                            <span>Back</span>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary" style="position: relative;"
                            (disabled)="isDisabled">
                            <span>Save &amp; Continue Securely</span>
                            <app-spinner *ngIf="submitting" class="signupSubmitSpinner"></app-spinner>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-slide>